import { v4 as uuidv4 } from 'uuid'
import {
  INFO_CERTIFICATE,
  INFO_DOCUMENT,
  INFO_EDUC,
  INFO_EMER,
  INFO_PERSONAL,
  INFO_WORK,
  PIM_EMP_INFO
} from '../../../router/routes'

export default function fnSubCardMenu(d) {
  // const dispatch = useDispatch()

  // useEffect(() => {
  //   dispatch(updateMenuSubCard(d))
  // }, [])

  switch (d.id) {
    // Job Position
    case 1:
      return {
        menuId: d.id,
        id: uuidv4(),
        label: d.card_sub_name,
        link: PIM_EMP_INFO,
        key: 0,
        icon: null
      }
    // Personal Details
    case 2:
      return {
        menuId: d.id,
        id: uuidv4(),
        label: d.card_sub_name,
        link: INFO_PERSONAL,
        key: 1,
        icon: null
      }
    // emergency
    case 3:
      return {
        menuId: d.id,
        id: uuidv4(),
        label: d.card_sub_name,
        link: INFO_EMER,
        key: 2,
        icon: null
      }
    // education
    case 4:
      return {
        menuId: d.id,
        id: uuidv4(),
        label: d.card_sub_name,
        link: INFO_EDUC,
        key: 3,
        icon: null
      }
    // Work History
    case 5:
      return {
        menuId: d.id,
        id: uuidv4(),
        label: d.card_sub_name,
        link: INFO_WORK,
        key: 4,
        icon: null
      }
    // Document
    case 6:
      return {
        menuId: d.id,
        id: uuidv4(),
        label: d.card_sub_name,
        link: INFO_DOCUMENT,
        key: 5,
        icon: null
      }
    // certificate
    case 7:
      return {
        menuId: d.id,
        id: uuidv4(),
        label: d.card_sub_name,
        link: INFO_CERTIFICATE,
        key: 6,
        icon: null
      }
    default:
      break
  }
}
